<template>
  <div>
    <b-card>
      <page-title v-if="titleStatus" :title="$t('sponsors.items')" />

      <main-table
        :fields="fields"
        :list_url="'admin/sponsor'"
        :items="items"
        :reloadData="reloadData"
        :params="filter"
        :createBtnLabel="$t('sponsors.create')"
        createRouteName="events.sponsorCreate"
        :excelFields="excelFields"
        excelName="sponsors"
        :downloadSampleStatus="true"
        downloadSampleUrl="sponsor/excel-sample"
        :uploadFileStatus="true"
        uploadFileUrl="sponsor/excel"
      />
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import SponsorFilter from "../models/SponsorFilter";
import searchMixin from "../../../../Mixins/searchMixin";

export default {
  mixins: [searchMixin],
  data() {
    return {
      filter: new SponsorFilter(),
      fields: [
        this.$t("global.selected"),
        { key: "id", label: this.$t("table.id"), sortable: true },
        { key: "name", label: this.$t("table.name"), sortable: true },
        { key: "logo", label: this.$t("global.logo"), type: "image" },
        {
          key: "actions",
          label: this.$t("table.actions"),
          type: "actions",
          actions: [
            {
              text: this.$t("global.view"),
              icon: "fas fa-eye",
              color: "info",
              ifNavigate: true,
              routeName: "events.sponsorView",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.update"),
              icon: "fas fa-pen",
              color: "primary",
              ifNavigate: true,
              routeName: "events.sponsorUpdate",
              routeParams: ["id"],
            },
            {
              text: this.$t("global.delete"),
              icon: "fas fa-trash-alt",
              color: "danger",
              showAlert: true,
              actionHeader: this.$t("global.delete"),
              titleHeader: this.$t("sponsors.item"),
              textContent: "name",
              url: "admin/sponsor",
              type: "delete",
            },
          ],
        },
      ],
      excelFields: {
        [this.$t("table.id")]: "id",
        [this.$t("table.name")]: "name",
        [this.$t("global.url")]: "url",
        [this.$t("table.createdAt")]: "created_at",
      },
    };
  },
  props: {
    items: { type: Array, default: () => [] },
  },
  mounted() {
    core.index();
  },
};
</script>
